var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendedItemIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_639_18120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3396 47.34C69.5558 69.5562 -5.55371 69.5562 16.6625 47.34C-5.55371 69.5562 -5.55371 -5.55325 16.6598 16.6602C-5.55646 -5.55601 69.553 -5.55601 47.3368 16.6602C69.553 -5.55601 69.553 69.5535 47.3368 47.3373L47.3396 47.34Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_639_18120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedItemIcon4);
export default __webpack_public_path__ + "static/media/recommendedItemIcon4.69152f03f679ca4faaa3b0f13bfe2ad8.svg";
export { ForwardRef as ReactComponent };